import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Location } from '@reach/router';

import { FaSpotify, FaAngleRight } from 'react-icons/fa';

import { authorizeUrl } from '../../api/spotify';
import { stepClassName } from '../../helpers';
import { reset, setStep } from '../../state/app';

class Step1 extends Component {

  handleSpotifyConnect(location) {
    window.location.replace(authorizeUrl(location));
  }

  render() {
    return (
      <div id="step1" className={'bg-blue-light step ' + stepClassName(1, this.props.step)}>
        <h2 className="step-title" onClick={() => this.props.setStep(1)}>
          1. Connect akun Spotify kamu
        </h2>
        <div className="step-content">
          <p className='mb-6'>
            Hi! Selamat datang di Videotify!
          </p>

          <p className='mb-6'>
            Videotify mempermudah kamu dalam menonton video klip dari lagu-lagu di Spotify.
          </p>

          { this.props.spotifyAccessToken &&
            <div>
              <p className='mb-6'>
                Sepertinya akun spotify kamu sudah terkoneksi.  Keren my bro!
              </p>
              <p className='mb-6'>
                <button
                  className="btn text-xl"
                  onClick={() => this.props.setStep(2, true)}
                >
                  Lanjut ke Step 2 dan pilih sebuah Playlist <FaAngleRight className="align-middle" />
                </button>
              </p>
              <p className='mb-6'>
                <button className='cursor-pointer underline text-white text-sm' onClick={() => this.props.reset()}>Disconnect akun</button>
              </p>
            </div>
          }

          { !this.props.spotifyAccessToken &&
            <div>
              <p className='mb-6'>
                Untuk memulai, klik tombol ini untuk mengkoneksikan akun spotify kamu.
              </p>

              <Location>
                {({ navigate, location }) =>
                  <button
                    className="btn text-xl"
                    onClick={() => this.handleSpotifyConnect(location) }
                  >
                    <FaSpotify className="align-middle" /> Klik untuk menghubungkan Akun Spotify kamu
                  </button>
                }
              </Location>
            </div>
          }

        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    step: state.app.step,
    spotifyAccessToken: state.app.spotifyAccessToken
  }
}

const mapDispatchToProps = dispatch => {
  return {
    reset: () => { dispatch(reset()) },
    setStep: (step, skipCheck) => { dispatch(setStep(step, skipCheck)) }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step1);
